export default __webpack_public_path__ + "static/media/waist-circumference.845191be.svg";